import { request } from '../utils/request';
import type {
  AccountsListResponse,
  Account,
  CreateAccountRequest,
  UpdateAccountRequest,
  AccountsDashboardResponse,
  DriverNotificationConfig,
} from '../types/accounts.types';

export const getAccounts = async (): Promise<AccountsListResponse> => {
  return request<AccountsListResponse>('/accounts/list');
};

export const getAccount = async (uuid: string): Promise<Account> => {
  return request<Account>(`/accounts/${uuid}`);
};

export const createAccount = async (
  data: CreateAccountRequest,
): Promise<{ message: string; uuid: string }> => {
  return request('/accounts', {
    method: 'POST',
    body: data,
  });
};

export const updateAccount = async (
  uuid: string,
  data: UpdateAccountRequest,
): Promise<{ message: string }> => {
  return request(`/accounts/${uuid}`, {
    method: 'PUT',
    body: data,
  });
};

export const deactivateAccount = async (
  uuid: string,
): Promise<{ message: string }> => {
  return request(`/accounts/${uuid}/deactivate`, {
    method: 'POST',
  });
};

export const activateAccount = async (
  uuid: string,
): Promise<{ message: string }> => {
  return request(`/accounts/${uuid}/activate`, {
    method: 'POST',
  });
};

export const getAccountsDashboard =
  async (): Promise<AccountsDashboardResponse> => {
    return request<AccountsDashboardResponse>('/accounts');
  };

export const getNotificationSettings = async (
  uuid: string,
): Promise<DriverNotificationConfig | null> => {
  return request<DriverNotificationConfig | null>(
    `/accounts/${uuid}/notification-settings`,
  );
};

export const updateNotificationSettings = async (
  uuid: string,
  data: DriverNotificationConfig,
): Promise<{ message: string }> => {
  return request(`/accounts/${uuid}/notification-settings`, {
    method: 'PUT',
    body: data,
  });
};
